import { createSlice } from '@reduxjs/toolkit';
import  type { NotificationState } from '../data/interfaces/sharedmodels';


// Define the initial state using that type
const initialState: NotificationState = {
  IsOpen: false,
  Message:'',
  Type:'info'
}
export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showerrormessage: (state,action) => {
      state.IsOpen=true;
      state.Message=action.payload.replace('rolling back transaction due to previous errors\r\nThe transaction ended in the trigger. The batch has been aborted.\r\n','');
      state.Type='error'
    },
    showwarningmessage: (state,action) => {
        state.IsOpen=true;
        state.Message=action.payload;
        state.Type='warning'
      },
      showinfomessage: (state,action) => {
        state.IsOpen=true;
        state.Message=action.payload;
        state.Type='info'
      },
      showsuccessmessage: (state,action) => {
        state.IsOpen=true;
        state.Message=action.payload;
        state.Type='success'
      },
      closealert:(state)=>{
        state.IsOpen=false;
      }
  },
});

export const { showerrormessage,showinfomessage,showsuccessmessage,showwarningmessage,closealert } = notificationSlice.actions

export default notificationSlice.reducer